// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-item[data-v-4dcae088] {\n  background-color: var(--magic-tertiary, #1f2223);\n}", ""]);
// Exports
module.exports = exports;
